<template>
  <transition name="demo">
    <div class="toast" v-show="theToast">
      {{msg}}
    </div>
  </transition>
</template>

<style lang="less" scoped>

</style>

<script>
export default {
  name: 'Toast',
  data () {
    return {
      theToast: false,
      msg: ''
    }
  },
  mixins: [],
  components: {},
  mounted () {

  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/toast/toast.vue